import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-comite-credito',
  templateUrl: './comite-credito.component.html',
  styleUrls: ['./comite-credito.component.css']
})
export class ComiteCreditoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
